module.exports = __webpack_public_path__ + "static/media/Logo.75d1c070.svg";